import { ICommonCart, ICommonCartStaticHostingItem, ICommonRemoveItemFromCartRequest } from '@cuspar/ywt.ch.model';
import { PriceGadget } from '../UI/PriceGadget';
import { Trash2 } from 'lucide-react';
import { useCartStore } from '../../state/cartStore';
import { useTranslation } from 'react-i18next';

export const CartBannerStaticHostingItem = ({ cart, staticHostingItem }: { cart: ICommonCart; staticHostingItem: ICommonCartStaticHostingItem }) => {
  const { t } = useTranslation();
  const removeItemFromCart = useCartStore((state) => state.removeItemFromCart);

  async function hanndleRemoveStaticHosting() {
    const request: ICommonRemoveItemFromCartRequest = {
      type: 'staticHosting',
    };
    removeItemFromCart(cart.id, request);
  }

  return (
    <div className='w-full flex flex-col items-start gap-2 rounded-xs border p-3 text-left text-sm transition-all hover:bg-accent bg-muted mb-3'>
      <div className='flex w-full justify-between items-center'>
        <div className='font-semibold'>{t('checkout.plan', { plan: staticHostingItem.plan })}</div>
        <Trash2 onClick={hanndleRemoveStaticHosting} className='cursor-pointer hover:text-destructive h-4 w-4' />
      </div>
      <div className='flex w-full flex-col gap-1'>
        <div className='flex items-center'>
          <div className='flex items-center gap-2'>
            <div className='text-xs font-medium'>{t('checkout.websiteHosting')}</div>
          </div>
          <div className='ml-auto text-xs text-foreground'>
            <PriceGadget price={staticHostingItem.price} currency={cart.currency} />
          </div>
        </div>
      </div>
    </div>
  );
};
